import React, { memo } from 'react';

// Libraries
import { Col, Container, Row } from 'react-bootstrap';
import { PropTypes } from "prop-types";
import { m } from "framer-motion";

// Components
import { fadeIn } from "../../Functions/GlobalAnimations";
import { TabData01 } from './TabData';
import { Link } from 'react-router-dom';

// SCSS
import "../../Assets/scss/default.scss";

const TabTraffic = (props) => {
    return (
        <Container>
            <Row>
                {props.data[0].components?.map((component, index) => (
                    <m.div 
                        className='col-12 col-md-6 mb-4' 
                        {...{ ...fadeIn, transition: { duration: 0.9 }, viewport: { once: false } }}
                        key={index}
                    >
                        <div className="d-flex flex-column align-items-start">
                            {component.img && <img height="434" width="555" className="w-100 mb-3" src={component.img} alt="tab" />}
                            {component.subtitle && (
                                <span className="text-gradient mb-2 font-serif text-md font-medium uppercase inline-block leading-[20px]" 
                                      style={{backgroundImage: "linear-gradient(to right,#71bdea 0,#775ea5 100%)"}}>
                                    {component.subtitle}
                                </span>
                            )}
                            {component.title && <h5 className="font-serif font-semibold text-darkgray tracking-[-0.5px] mb-3">{component.title}</h5>}
                            {component.content && <p className="text-justify mb-3">{component.content}</p>}
                            {(component.buttonLink && component.buttonTitle) && (
                                <Link aria-label="tab button" 
                                      className="btn-fill rounded-none font-medium font-serif tracking-[1px] uppercase btn-fancy mb-2" 
                                      size="md" 
                                      to={component.buttonLink} 
                                      target="_blank" 
                                      title={component.buttonTitle}>
                                    {component.buttonTitle}
                                </Link>
                            )}
                            {(component.buttonLink1 && component.buttonTitle1) && (
                                <Link aria-label="tab button" 
                                      className="btn-fill rounded-none font-medium font-serif tracking-[1px] uppercase btn-fancy" 
                                      size="md" 
                                      to={component.buttonLink1} 
                                      target="_blank" 
                                      title={component.buttonTitle1}>
                                    {component.buttonTitle1}
                                </Link>
                            )}
                        </div>
                    </m.div>
                ))}
            </Row>
        </Container>
    );
};

TabTraffic.defaultProps = {
    data: TabData01
};

TabTraffic.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.exact({
            tabTitle: PropTypes.string,
            subtitle: PropTypes.string,
            title: PropTypes.string,
            img: PropTypes.string,
            content: PropTypes.string,
            buttonLink: PropTypes.string,
            buttonTitle: PropTypes.string,
            components: PropTypes.arrayOf(PropTypes.shape({
                img: PropTypes.string,
                title: PropTypes.string,
                subtitle: PropTypes.string,
                content: PropTypes.string,
                buttonLink: PropTypes.string,
                buttonTitle: PropTypes.string,
                buttonLink1: PropTypes.string,
                buttonTitle1: PropTypes.string
            }))
        })
    ),
};

export default memo(TabTraffic);